export default "__VITE_ASSET__CisFj$6o__"